import React from "react";
import { Callout, ClassificationIcon, CountChip, Section } from "@sscs/ui";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { threatNameFiltered } from "../../../../store/malwareSlice";
import { isMaliciousOrSuspicious } from "../../../../utils";
import { LinkToReportTab } from "../../../common";
import { useReportDispatch } from "../../../hooks";
import styles from "./classification.module.scss";
import { getClassificationStatistics, getSuppressedClassification, getSuppressionReason, } from "./utils";
const ThreatType = ({ threatType, count, isTriaged, }) => {
    const dispatch = useReportDispatch();
    return (React.createElement("div", { className: styles.detection },
        React.createElement(LinkToReportTab, { id: `${threatType} Details`, to: REPORT_PAGES_ROUTES.MALWARE_ROUTE, color: "link", onClick: () => dispatch(threatNameFiltered({
                threat_name: threatType,
                hide_triaged: !isTriaged,
            })) }, threatType),
        React.createElement(CountChip, null,
            "\u00D7",
            count)));
};
const Classification = ({ classification, }) => {
    const detections = getClassificationStatistics(classification);
    const isSuppressed = !isMaliciousOrSuspicious(classification.classification);
    const displayClassification = isSuppressed
        ? getSuppressedClassification(classification.overrides)
        : classification.classification;
    const suppressionReason = getSuppressionReason(classification);
    return (React.createElement(Section, null,
        React.createElement(Section.Title, { as: "h3" },
            React.createElement("span", { className: styles.title },
                React.createElement(ClassificationIcon, { classification: displayClassification, hasGoodwareOverrides: isSuppressed }),
                displayClassification,
                isSuppressed ? (React.createElement("span", { className: styles.suppressed }, "(suppressed)")) : null)),
        React.createElement(Section.Content, null,
            detections.length > 0 ? (React.createElement("div", { className: styles.detections }, detections.map((detection) => (React.createElement(ThreatType, { key: detection.threat_type, threatType: detection.threat_type, isTriaged: isSuppressed, count: detection.total_count }))))) : null,
            isSuppressed && suppressionReason ? (React.createElement("div", { className: styles["suppressed-note"] },
                React.createElement(Callout, { type: "info", title: "Classification suppressed" }, suppressionReason))) : null)));
};
export default Classification;
//# sourceMappingURL=Classification.js.map